import { ImgHTMLAttributes } from "react";

export const LogoWhiteOnBlack = (props?: ImgHTMLAttributes<Element>) => {
  return <img src="/logoWhiteOnBlack.svg" {...props} alt="Logo" />;
};
export default LogoWhiteOnBlack;
